export default __webpack_public_path__ + "static/media/Gonzales.14253e5f.mp4";